import axios from 'axios'
import { salvarAmbiente, removerAmbiente } from '../util/applicationContext'
import { BYPASS_AUTH_INTERCEPTOR_CONFIG } from '../interceptors/authenticationJwtInterceptors'

export const AMBIENTE_INICIADO = '@ambienteActions/AMBIENTE_INICIADO'
export const AMBIENTE_DESCARTADO = '@ambienteActions/AMBIENTE_DESCARTADO'
export const ambienteUrl = '/bff/publico/ambiente'
export const axiosWrapper = axios

export const recuperarAmbiente = (callback) => {
  return (dispatch) => {
    axios.get(ambienteUrl, BYPASS_AUTH_INTERCEPTOR_CONFIG).then((response) => {
      const ambiente = response.data
      salvarAmbiente(ambiente)
      if (callback) {
        callback()
      }
      return dispatch({
        type: AMBIENTE_INICIADO,
        payload: ambiente
      })
    })
  }
}

export const descartarAmbiente = () => {
  removerAmbiente()
  return {
    type: AMBIENTE_DESCARTADO
  }
}
